import { serializeQuery, type QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteria } from '../model/types';
import { checkInDateRange } from './toUrl/checkInDateRange';
import { fromCity } from './toUrl/fromCity';
import { hotelCategories } from './toUrl/hotelCategories';
import { hotels } from './toUrl/hotels';
import { meals } from './toUrl/meals';
import { nightRange } from './toUrl/nightRange';
import { resorts } from './toUrl/resorts';
import { toCountries } from './toUrl/toCountries';
import { touristGroup } from './toUrl/touristGroup';

/**
 * Query-string для поиска горящих туров (порт `Domain/Hydrator/toRouterHot.js`).
 * Особенности паритета с источником: нет `toCountry` (singular); `toCountries`
 * (множественные страны через `.`) добавляется ПОСЛЕ `otherCriteria`.
 */
export function getHotToursUrl(criteria: SearchCriteria, otherCriteria: QueryObject = {}): string {
  const params: QueryObject = {
    ...fromCity(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotelCategories(criteria),
    ...meals(criteria),
    ...hotels(criteria),
    ...otherCriteria,
    ...toCountries(criteria),
  };

  return serializeQuery(params);
}
